import request from '@/axios'
import eRequest from '@/axios/eContract'
import post from '@/axios/upload'

// 合同法大大
// 获取实名认证地址
export function authent(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/user/user/authent',
    method: 'post',
    data
  })
}
// 用户信息
export function getUserInfo(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/user/user/get_user_info',
    method: 'post',
    data
  })
}
// 合同预览页接口
export function contract(data) {
  return eRequest({
    url: process.env.VUE_APP_BASE_API_ECONTRACT + '/contract/contract/index',
    method: 'post',
    data
  })
}
// TODO:需要传入token
// 撤销合同
export function voidContract(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/voidContract',
    method: 'post',
    data
  })
}

// G-1108-发送电子合同到企业微信控制台
export function sendContractDing(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/sendContractDing',
    method: 'post',
    data
  })
}
// G-0802-获取合同详情
export function getContractInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/getContractInfo',
    method: 'post',
    data
  })
}
// G-0803-添加合同资源
export function saveOrderContractResource(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/saveOrderContractResource',
    method: 'post',
    data
  })
}
// 获取权限列表
export function upLoadImage(file, data) {
  const param = new FormData()
  param.append('file', file)
  if (data) {
    Object.keys(data).forEach(element => {
      param.append(element, data[element])
    })
  }
  return post({
    url: '//upload.qiniup.com',
    method: 'post',
    data: param,
    config: {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  })
}

// 获取门店包列表
export function buildCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/buildCode',
    method: 'post',
    data
  })
}

// 发送电子邮件
export function sendEmail(data) {
  return process.env.VUE_APP_BASE_API_ECONTRACT + eRequest({
    url: '/contract/contract/send_email',
    method: 'post',
    data
  })
}
// 获取上传图片Token
export function getUploadToken(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/getUploadToken',
    method: 'post',
    data
  })
}
